import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hkkchf48fc: FaireBrandEntity = {
  token: "b_hkkchf48fc",
  type: "brand",
  name: "Short and Sweet",
  avatarUrl:
    "https://cdn.faire.com/fastly/8a141fc5fa71b3e60ab1b26d55ffddb8342ffd5f3e96fa877ff4b8714f3aad53.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/319571147f7f1f294605fe79fa3d2997f319527e4bb66cc3a864c13903a6d3ba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8a141fc5fa71b3e60ab1b26d55ffddb8342ffd5f3e96fa877ff4b8714f3aad53.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/319571147f7f1f294605fe79fa3d2997f319527e4bb66cc3a864c13903a6d3ba.jpeg",
  location: "Edison, NJ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 3,
  isTopShop: true,
  isInsider: true,
  description:
    "Sometimes, a little says a lot —\nand means a lot, too. Whether\nincluded with a gift or given on\ntheir own, our cute and trendy\nmini greeting cards are the perfect\nway to add a smile to someone's\nday. With just a few words on\nthe outside, they are BLANK inside\nfor you to add your own\npersonalized message. Perfectly\npetite, expertly designed\nand crafted, forever treasured.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:44.242Z",
    importedBy: "entity-db-cli",
  },
};
